import { Injectable, WritableSignal, signal, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { toObservable } from '@angular/core/rxjs-interop';

import { Observable, map, catchError, throwError } from 'rxjs';

import { environment } from '@environments/environment';
import { serverEnvironment } from '@environments/environment.server';
import { GlobalsService } from '@services/globals.service';
import { SsrService } from '@services/ssr.service';
import { FilterParams } from '@models/filter.model';
import { ListItem, ListDataResponse, ListBanner } from '@models/list.model';

export interface ListData {
  data: FilterParams;
  page: number;
  sort: number;
  limit?: number;
  loadMore?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ListService {
  private http = inject(HttpClient);
  private globalsService = inject(GlobalsService);
  private ssrService = inject(SsrService);
  public pages: WritableSignal<number> = signal(1);
  public itemsPerPage: WritableSignal<number> = signal(35);
  public cars: WritableSignal<(ListBanner | ListItem)[]> = signal([]);
  public cars$: Observable<(ListBanner | ListItem)[]> = toObservable(this.cars);
  public count: WritableSignal<number> = signal(0);
  public loaded: WritableSignal<boolean> = signal(false);

  getListData(data: ListData = { data: {}, page: 1, sort: 21, limit: this.itemsPerPage(), loadMore: false }): Observable<ListDataResponse> {
    if (data.limit && data.limit !== this.itemsPerPage()) this.itemsPerPage.set(data.limit);
    const skip: number = (data.page - 1) * this.itemsPerPage();
    if (!data.loadMore) this.cars.set([]);
    this.loaded.set(false);
    data.data.leasingNumberOfMonth = 60;

    return this.http
      .post<ListDataResponse>(`${this.ssrService.isServer() ? serverEnvironment.carsApi : environment.carsApi}?withEquipCat=1&responseFormat=list&withCount=1&limit=` + this.itemsPerPage() + '&skip=' + skip + '&sort=' + data.sort + '&withDetails=1', data.data, {
        headers: this.globalsService.headerHash(),
      })
      .pipe(
        map((response) => {
          this.loaded.set(true);
          if (response.message?.items) {
            for (let car of response.message.items) {
              car.gallery = [];
              if (car.photos?.default === null) car.photos.default = [{ type: 4, url: ['https://static.aaaauto.eu/img/nophoto/nophoto-big.jpg'] }];
              if (car.photos?.default?.[0]?.url) {
                for (let photo of car.photos.default[0].url) {
                  photo = this.globalsService.replacePlaceholderPhoto(photo, '1600x1200x100');
                }
              }
            }
          }
          return response;
        }),
        catchError((error) => {
          console.error('Error fetching car list data:', error);
          this.loaded.set(true);
          this.cars.set([]);

          const errorResponse: ListDataResponse = {
            code: error.status,
            message: {
              items: [],
              total: 0,
            },
          };

          return throwError(() => errorResponse);
        }),
      );
  }

  setPages(count: number): void {
    this.count.set(count);
    this.pages.set(Math.ceil(count / this.itemsPerPage()));
  }
}
